import { render, staticRenderFns } from "./RegistrarChamadas.vue?vue&type=template&id=6b0dcc13"
import script from "./RegistrarChamadas.vue?vue&type=script&lang=ts"
export * from "./RegistrarChamadas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports